
import { range } from 'vessel/utils'

export default {
  name: 'VsPaginationPager',
  inject: ['pagination'],
  vessel: {
    wrapper: {
      $disabled: {
        pointerEvents: val => val ? 'none' : null,
        color: val => val ? 'grey' : null
      }
    },
    button: {
      display: 'flex',
      flexItems: 'center',
      flexJustify: 'center',
      paddingX: '2xs'
    },
    separator: {
      $extend: 'button',
      fontSize: 'sm',
      pointerEvents: 'none'
    },
    link: {
      $extend: 'button',
      cursor: 'pointer',
      hover: {
        color: 'primary'
      }
    },
    active: {
      $extend: 'link',
      color: 'primary'
    }
  },
  computed: {
    disabled() {
      return this.pagination.disabled
    },
    pages() {
      const total   = this.pagination.totalPages
      const current = this.pagination.currentPage
      const count   = this.pagination.pagerCount

      if (total <= count) {
        return range(1, total)
      }

      const innerLimit = Math.floor((count - 3) / 2)
      const outerLimit = 0

      let middleMin = current - innerLimit
      let middleMax = current + innerLimit

      let leftMin = 1
      let leftMax = leftMin + outerLimit

      let rightMin = total - outerLimit
      let rightMax = total

      if (middleMin <= leftMax) {
        middleMin = leftMax + 1
        middleMax = middleMin + innerLimit + 1
      }

      if (middleMax >= rightMin) {
        middleMax = rightMin - 1
        middleMin = middleMax - innerLimit - 1
      }

      let left   = range(leftMin, leftMax)
      let middle = range(middleMin, middleMax)
      let right  = range(rightMin, rightMax)

      const size = left.length + middle.length + right.length

      if (size < total) {
        if (middleMin > leftMax + 1) {
          middle.unshift(null)
        } else {
          right.unshift(rightMax - 1)
        }

        if (middleMax < rightMin - 1) {
          middle.push(null)
        } else {
          left.push(leftMin + 1)
        }
      }

      return [].concat(left, middle, right)
    }
  },
  methods: {
    pageClass(page) {
      return this.pagination.currentPage == page
        ? this.$vessels.active
        : this.$vessels.link
    },
    itemKey(page, index) {
      return page ? `page-${page}` : `sep-${index}`
    }
  }
}
